import { Accordion, Nav } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function T8_pins_mnu({permission, setactivity, activeItem}) {
  const navigate = useNavigate();
  const activeStyles = { fontWeight: 600, backgroundColor: '#e7f1ff', color: '#0d6efd' };
 
  return (
    <Accordion.Item eventKey="8">
      <Accordion.Header>
        <span role="img" aria-label="pins">🔐</span> Admin Subscriptions
      </Accordion.Header>
      <Accordion.Body className="p-0">
        <Nav className="flex-column">
          {(permission === '1' || permission === '3') && (
            <Nav.Link
              active={activeItem === 'pins_lotes'}
              style={activeItem === 'pins_lotes' ? activeStyles : undefined}
              onClick={() => {
                navigate('/pins/lotes');
                setactivity && setactivity('PinsLotes');
              }}
            >
              Lotes de PINES
            </Nav.Link>
          )}
          {(permission === '1' || permission === '2' || permission === '3') && (
            <Nav.Link
              active={activeItem === 'pins_estado'}
              style={activeItem === 'pins_estado' ? activeStyles : undefined}
              onClick={() => {
                navigate('/pins/estado');
                setactivity && setactivity('PinsEstado');
              }}
            >
              Estado de PINES
            </Nav.Link>
          )}
          {permission === '3' && (
            <>
              <Nav.Link
                active={activeItem === 'pins_lotes_qa'}
                style={activeItem === 'pins_lotes_qa' ? activeStyles : undefined}
                onClick={() => {
                  navigate('/pins/qa/lotes');
                  setactivity && setactivity('PinsLotesQA');
                }}
              >
                Lotes de PINES QA
              </Nav.Link>
              <Nav.Link
                active={activeItem === 'pins_estado_qa'}
                style={activeItem === 'pins_estado_qa' ? activeStyles : undefined}
                onClick={() => {
                  navigate('/pins/qa/estado');
                  setactivity && setactivity('PinsEstadoQA');
                }}
              >
                Estado de PINES QA
              </Nav.Link>
            </>
          )}
          {(permission === '1' || permission === '3') && (
            <Nav.Link
              active={activeItem === 'pins_cupones'}
              style={activeItem === 'pins_cupones' ? activeStyles : undefined}
              onClick={() => {
                navigate('/pins/cupones');
                setactivity && setactivity('PinesCupones');
              }}
            >
              Cupones
            </Nav.Link>
          )}
          {permission === '3' && (
            <Nav.Link
              active={activeItem === 'pins_cupones_qa'}
              style={activeItem === 'pins_cupones_qa' ? activeStyles : undefined}
              onClick={() => {
                navigate('/pins/qa/cupones');
                setactivity && setactivity('PinesCuponesQA');
              }}
            >
              Cupones QA
            </Nav.Link>
          )}
        </Nav>
      </Accordion.Body>
    </Accordion.Item>
  );
}

export default T8_pins_mnu;
